































import { Vue, Component } from 'vue-property-decorator'
import EmailInput from 'components/auth/EmailInput.vue'
import PasswordInput from 'components/auth/PasswordInput.vue'
import CodeInput from 'components/auth/CodeInput.vue'
import GoogleSignIn from 'components/auth/GoogleSignIn.vue'
import AzureSignIn from 'components/auth/AzureSignIn.vue'

@Component({
  components: {
    EmailInput,
    PasswordInput,
    CodeInput,
    GoogleSignIn,
    AzureSignIn
  }
})
export default class AuthSignIn extends Vue {
  error = false
  step: string = 'email'
  email = ''
  response: Response | null = null

  shake () {
    this.error = true
    setTimeout(() => {
      this.error = false
    }, 500)
  }

  emailResponse (response: Response) {
    this.response = response
    if (response.status === 200) {
      this.step = 'password'
    } else {
      this.step = 'code'
    }
  }

  passwordResponse (response: Response) {
    this.response = response
    this.step = 'code'
  }
}
